// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function LightbulbIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M22 29a1 1 0 0 1-1 1H11a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1Zm5-16a10.944 10.944 0 0 1-4.205 8.651A2.03 2.03 0 0 0 22 23.25V24a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-.75a2 2 0 0 0-.779-1.582A10.949 10.949 0 0 1 5 13.06C4.968 7.104 9.783 2.143 15.735 2A11 11 0 0 1 27 13Zm-2 0a8.998 8.998 0 0 0-9.217-9c-4.875.115-8.81 4.174-8.783 9.049a8.956 8.956 0 0 0 3.455 7.037A4 4 0 0 1 12 23.25V24h8v-.75a4.018 4.018 0 0 1 1.559-3.169A8.957 8.957 0 0 0 25 13Zm-2.014-1.168a7.2 7.2 0 0 0-5.82-5.818 1 1 0 0 0-.332 1.972c2.071.349 3.829 2.106 4.18 4.182a1 1 0 1 0 1.972-.335Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
